<template>
  <div class="container">
    <b-col cols="12">
      <p>
        <strong>INSTRUCCIONES:</strong>
      </p>
      <p>{{data.instrucciones}}</p>
    </b-col>
    <div class="row">
      <b-col lg="6" style="text-align:center;">
        <v-stage ref="stage" :config="stageSize">
          <v-layer ref="layer">
            <v-image :config="configImg" />
            <v-text ref="text" v-for="t in pointsSelected" :config="t.configTxt" :key="t.index" />
            <v-circle v-for="(t,index) in pointsSelected" :config="t.configCircle" :key="index" @click="addLine($event)" />
          </v-layer>
        </v-stage>
      </b-col>
      <b-col lg="6" style="text-align:center;">
        <img class="img-recurso-prev" :src="$root.setUrlFile(data.file)" alt="">
      </b-col>
    </div>
  </div>
</template>
<script>
export default {
  name: "pre-dot",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          tag: "Dot",
          points: [],
          instrucciones: "",
          data: "",
          file: null
        };
      }
    }
  },
  data() {
    return {
      generandoCanvas: true,
      stageSize: {
        width: 500,
        height: 500,
        id: 'canvas'
      },
      configImg: {
        image: null,
        opacity: 0.1,
        width: 500,
        height: 500
      },
      pointsSelected: this.points
    };
  },
  created() {
    this.pointsSelected = this.data.points;
    console.log(this.data);
    setTimeout(() => {
      this.generandoCanvas = false;
      var elementKonva = document.getElementsByClassName("konvajs-content");
      elementKonva[0].classList.add("main-konva-stage");
    }, 100);
  },
  methods: {
    addLine(e){
      console.log(e);
    }
  }
};
</script>
<style scoped>
.main-konva-stage {
  margin: 0 auto !important;
}
.img-recurso-prev{
    display: block;
    margin: 0 auto !important;
    width: 500px;
    height: 500px;
    opacity: 0.2;
}
</style>